<template>
    <Header style="background:white;border-bottom-right-radius:3rem;border-bottom-left-radius:3rem;" />
    <div class="terms-container">
        <div class="title">
            <h1>Terms of Use</h1>
        </div>
        <div class="info">
            <h1>BY ACCESSING AND USING SHABEB AND ITS RELATED SERVICES IN ANY FORM, YOU ACCEPT AND AGREE TO BE BOUND BY AND ABIDE BY THE TERMS AND PROVISION OF THIS AGREEMENT. IN ADDITION, WHEN USING THESE PARTICULAR SERVICES, YOU SHALL BE SUBJECT TO ANY POSTED GUIDELINES OR RULES APPLICABLE TO THESE SERVICES.</h1>
            <p>Shabeb invites you to use all of its available services located at <router-link to="/">https://shabeb.com/</router-link> . These Terms of Use apply when you use the Shabeb website and any related mobile applications as well as when you communicate using our social media channels (such as Facebook or WhatsApp Messenger). The aim of Shabeb is to grow your business and reach more customers at the least cost possible. To ensure a safe and enjoyable Shabeb experience for all of our users, we have established these Terms of Use. Please read them carefully.</p>
            <p><span>Note: </span>The use of Shabeb and its services by minors is permitted (the age of minors depends on where you reside) along with parent and/or guardian supervision. Presentail is not liable for credit/debit card transactions performed by minors without the consent of a parent or guardian.</p>

        </div>
        <div class="terms">
            <div class="term">
                <h1>1. Shabeb Privacy Policy</h1>
                <p>You agree to Shabeb’s Privacy Policy, which explains how we collect, use, and protect the personal information that you provide to us. To review our Privacy Policy, click here.</p>

            </div>
            <div class="term">
                <h1>2. Disclaimer</h1>
                <p>THE ENTIRETY OF SHABEB AND ITS RELATED SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE.” SHABEB DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES, EXPRESS, IMPLIED, OR STATUTORY, NOT EXPRESSLY SET OUT IN THESE TERMS, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. IN ADDITION, SHABEB MAKES NO REPRESENTATION, WARRANTY, OR GUARANTEE REGARDING THE RELIABILITY, TIMELINESS, QUALITY, SUITABILITY, OR AVAILABILITY OF THE SERVICES OR ANY SERVICES OR GOODS REQUESTED THROUGH THE USE OF THE SERVICES, OR THAT THE SERVICES WILL BE UNINTERRUPTED OR FREE OF ERRORS. SHABEB DOES NOT GUARANTEE THE QUALITY, SUITABILITY, SAFETY, OR ABILITY OF THIRD PARTY PROVIDERS, SUCH AS THE VENDORS AVAILABLE ON OUR WEBSITE. PRESENTAIL SHALL NOT BE RESPONSIBLE OR LIABLE FOR THE ACCURACY, USEFULNESS, OR AVAILABILITY OF ANY INFORMATION TRANSMITTED OR MADE AVAILABLE VIA THE SITE, AND SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY ERROR OR OMISSIONS IN THAT INFORMATION. YOU AGREE THAT THE ENTIRE RISK ARISING OUT OF YOUR USE OF OUR SERVICES, AND ANY SERVICE OR GOOD REQUESTED IN CONNECTION THEREWITH, REMAINS SOLELY WITH YOU, TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW.</p>

            </div>
            <div class="term">
                <h1>3. Intellectual Property Rights</h1>
                <p>Shabeb and its services are operated by Presentail SAL with offices located at BDD 740, Beirut Digital District, Beirut, Lebanon. Shabeb and all its original content, features, and functionality are owned by Presentail SAL and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. All other third party trademarks, product names, and company names and respective logos appearing on the Shabeb website and respective services are the sole property of their respective owners.</p>

            </div>
            <div class="term">
                <h1>5. Terms and Conditions of Sales</h1>
                <div class="sub">
                    <h1>A. Shabeb Services and Pricing</h1>
                    <p>All of the services carried out by Shabeb are subject to change. Shabeb reserves the right, at any given time, to modify, suspend, or discontinue the provision of any service with or without prior notice. You agree that Shabeb will not be liable to you or to any third party for any modification, suspension, or discontinuance of any product. In the event that a specific service is listed at an incorrect price or with incorrect information due to typographical errors or errors in pricing or service descriptions and information received from our partners, Shabeb shall have the right to decline or cancel those orders, regardless of whether or not the order has been confirmed and/or your debit/credit card charged. In the event your credit/debit card or PayPal account has already been charged for the order and it is cancelled by us, we shall immediately issue a refund to your credit/debit card or PayPal account in the amount of the charge.</p>

                </div>
                <div class="sub">
                    <h1>B. Requesting a Service from Shabeb</h1>
                    <p>Upon requesting a service from Shabeb, you are making an offer to purchase this service, and such an offer is subject to our acceptance. Your receipt of a request confirmation from us does not indicate our acceptance of your order, nor does it constitute confirmation of our offer to provide such a service. We reserve the right at any time after the receipt of your request to accept, modify, decline, or cancel your request (in whole or in part) for any reason. Shabeb may require additional verifications or information before accepting and processing any order. Please review which information Shabeb may collect from you in our Privacy Policy. Shall Shabeb decide to cancel all or part of your request, we will either (1) issue a refund if you have been charged, or (2) not charge you for the cancelled portion of your request.</p>

                </div>
                <div class="sub">
                    <h1>C. Payment Policy</h1>
                    <p>Upon receiving a service provided by Shabeb - regardless of how the transaction was initiated -  you agree to pay the price or rate  applicable for the service as of the time you submitted your order, any applicable fees, and any applicable taxes. Billing agreements are agreed upon during the onboarding period. Should you choose to be billed monthly, a full payment for a bill that is free of errors must be made within seven (7) to thirty (30) days. After which, Shabeb holds the right to cease all service provisions unless the two parties formally agree in writing that the payment period be extended. Shall an error occur prior to, while, or after submitting an order digitally through our website or any other applicable means, a notice must be given to Shabeb within 24 hours.  If you have any questions or concerns regarding our Payment Policy, please reach out to us using the contact information provided at the end of this Terms of Use.</p>

                </div>
                <div class="sub">
                    <h1>D. Provision of Delivery Services</h1>
                    <p>Shabeb has  its own fleet of drivers for its delivery service and does not rely on any third-party delivery services/companies. We currently operate within the greater portion of Greater Beirut . Shabeb has the right to decline or cancel an order on the basis of vendor and/or recipient location/address. The safety of both our drivers and customers are of utmost importance while providing our services. Shabeb personnel and drivers abide by the laws and regulations set forth by the Lebanese government. All drivers must have work permits in Lebanon and hold a valid ID, driver’s license, and police records that are free from violations. The use of protective gear such as masks is obligatory per Lebanese law. Additional protective gear may be required in certain cases, such as surgical masks and gloves during the COVID-19 pandemic. Our delivery services are available within the company’s established working hours; to learn more about our active working hours, please reach out to us using the contact information provided at the end of this Terms of Use.  The provision of services might be interrupted or temporarily ceased due to external forces over which Shabeb has no control; these external forces may include Lebanese laws or regulations, lockdowns, medical emergencies, strikes, wars or armed conflicts, extreme weather conditions, or simply acts of God. Shabeb will always attempt to provide its services to the fullest extent possible, yet it is not to be held liable for lack of provision of services in such aforementioned extreme cases.</p>

                </div>
                <div class="sub">
                    <h1>E. Refund Policy</h1>
                    <p>When you request a service, it is final and nonrefundable, unless the below conditions are met. In the event that a delivery is delivered to the recipient in a damaged condition or does not arrive at all, we will refund the amount charged for the service. Additionally, if you believe you have been mistakenly billed, a notice must be sent within seven (7) days of receipt of a physical or digital bill or within 24 hours should you have paid on-the-spot.</p>

                </div>

            </div>
            <div class="term">
                <h1>6. Account Termination</h1>
                <p>Shabeb reserves the right to terminate your access to our website and services, without cause or notice, which may result in the forfeiture and destruction of all information associated with your Shabeb account. In the event we terminate your account on the basis of breach of terms, other fraudulent activity, or any other reason, we will refund you any credit remaining on your account.</p>

            </div>
            <div class="term">
                <h1>7. User Submissions</h1>
                <p>“User submissions” are any and all information and content that a user submits to, or uses with, the Shabeb website and its respective services. You are solely responsible for your user content and assume all risks associated with use of your user content. You hereby represent and warrant that your user content does not violate Shabeb’s Acceptable Use Policy available below. You may not state or imply that your user content is in any way provided, sponsored, or endorsed by Shabeb. Since only you, and not Shabeb, is responsible for your user content, you may expose yourself to liability if, for example, your user content does not meet the terms under our Acceptable Use Policy. Shabeb is not responsible for backing up any user content, and your user content may be deleted at any time.</p>
                <div class="sub">
                    <h1>A. Shabeb Acceptable Use Policy</h1>
                    <p>You agree not to use the Shabeb website and respective services to collect, upload, transmit, display, or display any user content:</p>
                    <p>(1) that violates any third-party right, including any copyrights, trademarks, patents, trade secrets, moral rights, privacy rights, rights of publicity, or any other intellectual property or proprietary right;</p>
                    <p>(2) that is illegal, harassing, abusive, tortious, threatening, harmful, invasive of another’s privacy, vulgar, defamatory, false, intentionally misleading, trade libelous, pornographic, obscene, patently offensive, promotes racism, bigotry, hatred, political messages, or physical harm of any kind against any group or individual or is otherwise objectionable;</p>
                    <p>(3) that is harmful to minors in any way;</p>
                    <p>(4)that is in violation of any law, regulation, or obligations or restrictions imposed by any third party;</p>
                    <p>(5) that constitutes a computer virus, worm, or any software intended to damage or alter a computer system or data; or</p>
                    <p>(6) that constitutes unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain letters, pyramid schemes, or any other form of duplicative or unsolicited messages, whether commercial or otherwise.</p>

                </div>
            </div>
            <div class="term">
                <h1>8. Notification Provision</h1>
                <div class="sub">
                    <h1>A. Modifications to Terms of Use</h1>
                    <p>Shabeb reserves the right to change these conditions periodically as it sees fit and your continued use of the site will signify your acceptance of any adjustment to these terms. Major changes to our Terms of Use will be announced via email, the website, or any other method the company finds suitable. However, Shabeb users are encouraged to regularly review our Terms of Use.</p>

                </div>
                <div class="sub">
                    <h1>B. Modifications to Shabeb Services</h1>
                    <p>Shabeb reserves the right to modify or discontinue certain parts of the website and/or our services at any time without prior notice. If you object to any changes to our website and related services, your sole recourse will be to stop using the site and service. Continued use of the Shabeb website and services indicates your acknowledgment and consent of any changes.</p>

                </div>
            </div>
            <div class="term">
                <h1>9. Contact Us</h1>
                <p>Thank you for reading Shabeb’s Terms of Use. We would like to hear your feedback regarding these Terms of Use or if you have any questions or concerns regarding any part of our Terms of Use. To contact us in this regard, please email us at <span>hello@shabeb.com</span>.</p>
            </div>
            <div class="modification">
                <p>Shabeb Delivery - Terms of Use Version 1.1</p>
                <h1>Last Modified: <span>April 15, 2020</span></h1>
                <h1>Effective Date: <span>April 17, 2020</span></h1>
            </div>
        </div>
    </div>
        <Footer />
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'

    export default {
        name: 'Terms',
        components:{
            Footer,
            Header,
        }
    }
</script>

<style scoped>
    .terms-container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 4rem 4rem;
        color: var(--color-primary);
        padding-top: 15rem;
    }
    .terms-container .title{
        margin: 3rem;
    }
    .terms-container .title h1{
        font-size: 5rem;
    }
    .terms-container .info{
        width: 100%;
        padding: 2rem;
    }
    .terms-container .info h1{
        font-size: 2rem;
        font-weight: 400;
        margin-bottom: 2rem;
    }
    .terms-container .info p{
        font-size: 1.5rem;
        letter-spacing: .2rem;
        margin-bottom: 1rem;
        line-height: 1.5;
        text-align: justify ;
    }
    .terms-container .info p span{
        font-weight: 800;
        font-size: 1.7rem;
    }
    .terms-container .info p a{
        color: var(--accent);
    }
    .terms-container .info p a:hover{
        color: var(--accent);
    }
    .terms-container .terms{
        position: relative;
        width: 100%;
        padding: 2rem;
        margin-bottom: 2rem;

    }
    .terms-container .terms .term{
        margin-bottom: 3rem;
        position: relative;
        width: 100%;
    }
    .terms-container .terms .term h1{
        font-size: 3rem;
        margin-bottom: 1rem;
    }
    .terms-container .terms .term p{
        font-size: 1.7rem;
        text-align: justify;
    }
    .terms-container .terms .term p span{
        color: var(--accent);
    }
    .terms-container .terms .term .sub{
        position: relative;
        width: 100%;
        padding: 2rem;
    }
    .terms-container .terms .term .sub h1{
        font-size: 2.5rem;
    }
    .modification{
        width: 100%;
        position: relative;
    }
    .modification p{
        font-style: italic;
        font-size: 1.5rem;
        margin-bottom: 2rem;
    }
    .modification h1{
        font-size: 2rem;
    }
    .modification h1 span{
        font-weight: 300;
    }
    @media screen and (max-width:479px) {
        .terms-container{
            padding: 1rem;
            padding-top: 15rem;
        }
        .terms-container .info, .terms-container .info ul,
        .terms-container .terms, .terms-container .terms .term sub
        {
            padding: 1rem;
        }
        .terms-container .title h1{
            font-size: 3rem;
        }
    }
</style>